/** Lean bulk queue is the default. Set REACT_APP_USE_LEAN_BULK_SEND=false to use TemplateQueue. */
export const USE_LEAN_BULK_SEND = process.env.REACT_APP_USE_LEAN_BULK_SEND !== 'false';

export const LEAN_BULK_MAX_ROWS = 15000;
